import React from 'react';
import { MonitorPlay, Play, ExternalLink } from 'lucide-react';

const telenovelas = [
  {
    title: 'Corazón de Oro',
    date: '2 Mar 2026',
    platform: 'Las Estrellas',
    streaming: 'ViX',
    streamUrl: 'https://vix.com/es-es/ondemandplus/novelas',
    genre: 'Romance / Drama',
    image: 'https://images.unsplash.com/photo-1540076156429-35ffe82b7870?w=280&h=350&fit=crop&q=70&fm=webp',
    accent: '#D4A017',
  },
  {
    title: 'Hermanas',
    subtitle: 'Un amor compartido',
    date: '2 Feb 2026',
    platform: 'Las Estrellas',
    streaming: 'ViX',
    streamUrl: 'https://vix.com/es-es/ondemandplus/novelas',
    genre: 'Drama familiar',
    image: 'https://images.unsplash.com/photo-1511405889574-b01de1da5441?w=280&h=350&fit=crop&q=70&fm=webp',
    accent: '#E11D48',
  },
  {
    title: 'Mi Rival',
    date: '30 Mar 2026',
    platform: 'Las Estrellas',
    streaming: 'ViX',
    streamUrl: 'https://vix.com/es-es/ondemandplus/novelas',
    genre: 'Suspenso / Drama',
    image: 'https://images.unsplash.com/photo-1661562595268-1319f8817037?w=280&h=350&fit=crop&q=70&fm=webp',
    accent: '#7C3AED',
  },
  {
    title: 'Doménica Montero',
    date: '19 Ene 2026',
    platform: 'Las Estrellas',
    streaming: 'Televisa',
    streamUrl: 'https://www.lasestrellas.tv/telenovelas',
    genre: 'Drama',
    image: 'https://images.unsplash.com/photo-1740930825862-bc909e7cdf16?w=280&h=350&fit=crop&q=70&fm=webp',
    accent: '#0891B2',
  },
  {
    title: 'Somos Familia',
    date: 'Mayo 2026',
    platform: 'Las Estrellas',
    streaming: 'Televisa',
    streamUrl: 'https://www.lasestrellas.tv/telenovelas',
    genre: 'Comedia / Familia',
    image: 'https://images.unsplash.com/photo-1507277197361-0a59220ee08d?w=280&h=350&fit=crop&q=70&fm=webp',
    accent: '#EA580C',
  },
];

const TVDramaWidget = () => (
  <div
    data-testid="telenovela-widget"
    className="col-span-1 md:col-span-4 bg-white rounded-3xl border border-[#E0DCD0] p-4 md:p-5 shadow-[0_8px_30px_rgba(28,58,39,0.04)]"
  >
    {/* Header */}
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-2">
        <MonitorPlay className="w-4 h-4 text-[#D74235]" />
        <p className="text-[10px] tracking-[0.2em] uppercase font-bold text-[#596A5F] font-['Figtree']">
          Telenovelas
        </p>
      </div>
      <span className="text-[9px] bg-[#1C3A27] text-white px-2 py-0.5 rounded-full font-bold tracking-wider font-['Figtree']">
        ESTRENOS 2026
      </span>
    </div>

    {/* Horizontal scroll on mobile, grid on desktop */}
    <div className="flex gap-3 overflow-x-auto pb-2 md:pb-0 md:grid md:grid-cols-5 md:overflow-visible scrollbar-hide">
      {telenovelas.map((show, i) => (
        <a
          key={i}
          href={show.streamUrl}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`telenovela-card-${i}`}
          className="group flex-shrink-0 w-[140px] md:w-auto rounded-xl overflow-hidden border border-[#E0DCD0] hover:border-[#D74235]/40 hover:-translate-y-1 hover:shadow-md transition-all duration-300"
        >
          {/* Image */}
          <div className="relative h-24 md:h-28 overflow-hidden">
            <img
              src={show.image}
              alt={show.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
            />
            {/* Gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
            {/* Play button on hover */}
            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <div className="w-10 h-10 rounded-full bg-white/90 flex items-center justify-center shadow-lg">
                <Play className="w-4 h-4 text-[#D74235] ml-0.5" fill="#D74235" />
              </div>
            </div>
            {/* Streaming badge */}
            <span
              className="absolute top-2 right-2 text-[9px] font-bold text-white px-2 py-0.5 rounded-full font-['Figtree'] tracking-wider"
              style={{ backgroundColor: show.accent }}
            >
              {show.streaming}
            </span>
            {/* Title on image */}
            <div className="absolute bottom-0 left-0 right-0 p-3">
              <h4 className="text-sm font-semibold text-white font-['Outfit'] leading-tight drop-shadow-lg">
                {show.title}
              </h4>
              {show.subtitle && (
                <p className="text-[10px] text-white/80 font-['Figtree'] mt-0.5">{show.subtitle}</p>
              )}
            </div>
          </div>

          {/* Info */}
          <div className="px-2 py-1.5 bg-[#F9F7F1]">
            <div className="flex items-center justify-between">
              <p className="text-[8px] font-semibold text-[#596A5F] font-['Figtree'] uppercase tracking-wide">
                {show.genre}
              </p>
              <div className="flex items-center gap-0.5 text-[8px] font-semibold text-[#D74235] font-['Figtree'] group-hover:underline">
                <ExternalLink className="w-2.5 h-2.5" />
                <span>{show.streaming}</span>
              </div>
            </div>
          </div>
        </a>
      ))}
    </div>
  </div>
);

export default TVDramaWidget;
